import Vue from 'vue';
import VueRouter from 'vue-router';

import PublicRoutes from '../pages/public/router';
import AdminRoutes from '../pages/admin/router';

import AuthService from '../services/auth/auth.service';
const authService = new AuthService();

Vue.use(VueRouter);

const routes = [
  {
    path: '/',
    redirect: '/login'
  },
  ...PublicRoutes,
  ...AdminRoutes,
  {
    path: '*',
    redirect: '/login'
  }
];

const router = new VueRouter({
  mode: 'history',
  base: process.env.BASE_URL,
  routes
});

router.beforeEach((to, from, next) => {
  const isLogged = authService.isLogged();

  if (to.matched.some(record => record.meta.requiresAuth)) {
    if (!isLogged) {
      next({
        path: '/login',
      });
      return;
    }
  }

  if (to.matched.some(record => record.meta.onlyAnonymous)) {
    if (isLogged) {
      next({
        path: '/admin',
      });
      return;
    }
  }

  next();
});

export default router;
